export default __webpack_public_path__ + "static/media/gcn.282cc819.svg";